/*
 * File: RenderLogin.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Renders the login page
 */
import React from "react";
import LoginFormHandler from "../handlers/LoginFormHandler";
import Login from "./Login";
import { PropTypes } from "prop-types";

const RenderLogin = ({ onLoginSuccess }) => (
  <LoginFormHandler onLoginSuccess={onLoginSuccess}>
    <Login />
  </LoginFormHandler>
);

RenderLogin.propTypes = {
  onLoginSuccess: PropTypes.func.isRequired
};

export default RenderLogin;
